import { parentReferralTestimonials } from "../../constants"
import ReferralTestimonialCard from "../../pages/referralLanding/ReferralTestimonialCard"

const ParentTestimonialWithRibbon = () => {
  return (
    <div className="flex flex-col items-center relative h-[300px]">
      <img
        src="/images/yellow-ribbon.png"
        alt="<="
        className="w-[100px] h-[60px] absolute top-1/2 left-0 translate-x-[-50%] translate-y-[-50%] user-select-none pointer-events-none"
      />
      <div className="flex flex-col items-center justify-center z-1">
        <ReferralTestimonialCard
          testimonial={parentReferralTestimonials[0]}
          isOnboarding
        />
      </div>
      <img
        src="/images/yellow-ribbon.png"
        alt="=>"
        className="w-[100px] h-[60px] absolute bottom-1/2 right-0 translate-x-[50%] translate-y-[50%] rotate-180 user-select-none pointer-events-none"
      />
    </div>
  )
}

export default ParentTestimonialWithRibbon
